import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=fa081980&scoped=true&"
import script from "./NavTop.vue?vue&type=script&lang=js&"
export * from "./NavTop.vue?vue&type=script&lang=js&"
import style0 from "./NavTop.vue?vue&type=style&index=0&id=fa081980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa081980",
  null
  
)

export default component.exports